export default "__VITE_ASSET__a23cac07__"